import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==========================================
// 2. DEFINE LIGHT GROUPS (The "Buckets")
// ==========================================

// --- STANDARD GROUPS (For Custom Builder) ---
// ==================================================================
// LIGHT AVAILABILITY GATES
//
// Modlite PL350 is no longer offered on any model - it is gone from every
// supported_lights and every quick-ship group below.
//
// XC2 / XVL2 / TLR-2 HL are offered ONLY on right-hand Glock 19, 17, 22 and
// 34/35. The *_RH lists keep them; the plain lists do not. Every other model
// reads a plain list, and those five Glock entries carry the plain list as
// supported_lights_lh, so the three are unreachable on a left-hand build.
//
// All of these ids stay in the light catalog - they are simply not offered.
// ==================================================================
const RH_GLOCK_ONLY = ["xc2", "xvl2", "tlr2"];
const noRhGlockOnly = (arr) => arr.filter(id => !RH_GLOCK_ONLY.includes(id));

export const LIGHTS_UNIVERSAL_RH = [
  "tlr1", "tlr1_hlx", "tlr7", "tlr7_hlx",
  "x300u_a", "x300u_b", "surefire_xc1b", "surefire_xc1c", "surefire_xc3",
  "inforce_apl", "inforce_apl_3", "inforce_wild1", "inforce_aplc_uni",
  "olight_pl_mini", "olight_pl_mini2", "olight_pl2", "olight_pl_pro",
  "sig_foxtrot1x", "sig_foxtrot2r", "tlr2", "xc2", "xvl2"
];
export const LIGHTS_UNIVERSAL = noRhGlockOnly(LIGHTS_UNIVERSAL_RH);

// Staccatos and Walther Steel Frames omit TLR-7 HL-X completely
export const LIGHTS_NO_TLR7HLX = LIGHTS_UNIVERSAL.filter(id => id !== "tlr7_hlx");

export const LIGHTS_GLOCK_RH = [
  ...LIGHTS_UNIVERSAL_RH.filter(id => id !== "inforce_aplc_uni"),
  "inforce_aplc_glock",
  // inforce_wild2 is quick ship on the Glock CNC programs below - it must be
  // present here or it never renders and that QS entry is unreachable.
  // (Modlite PL350 used to sit here too; it is no longer offered anywhere.)
  "inforce_wild2"
];
export const LIGHTS_GLOCK = noRhGlockOnly(LIGHTS_GLOCK_RH);

// GTL 10 specific group for G17, G19, G34
export const LIGHTS_GLOCK_GTL_RH = [ ...LIGHTS_GLOCK_RH, "gtl_10", "x400" ];
export const LIGHTS_GLOCK_GTL = noRhGlockOnly(LIGHTS_GLOCK_GTL_RH);

export const LIGHTS_SIG_SUB = [ "tlr7_sub_p365", "surefire_xsc", "tlr6" ];
export const LIGHTS_SIG_365_STD = [ "surefire_xsc", "tlr7_sub_p365", "tlr6" ];
export const LIGHTS_SIG_365_XL = [ "surefire_xsc", "tlr7_sub_p365", "tlr6" ];
export const LIGHTS_SIG_MACRO = [ "tlr7", "tlr7_hlx", "tlr7_sub_1913", "sig_foxtrot2r", "tlr6" ];
export const LIGHTS_SIG_AXG_GEN1 = [ "tlr7_sub_1913", "sig_foxtrot2r" ]; // Added for Gen 1 ONLY

export const LIGHTS_MICRO = [ "tlr7_sub_glock", "tlr6" ];
export const LIGHTS_SUB_1913 = [ "tlr7_sub_1913" ];
export const LIGHTS_TLR6_ONLY = [ "tlr6" ];


// --- QUICK SHIP (5-7 DAY) SPECIFIC GROUPS ---

// TLR-1 HL-X (tlr1_hlx) is CUSTOM LEAD TIME ONLY.
// Its fitment differs from the original TLR-1 and the TLR-1 HL, so it is
// deliberately kept OUT of every quick-ship group below. It stays in
// LIGHTS_UNIVERSAL / supported_lights so it remains orderable as a custom build.

const LIGHTS_QS_ARCHON = ["x300u_a", "x300u_b"]; 
const LIGHTS_QS_AREX_DELTA = ["tlr7"]; 
const LIGHTS_QS_BERETTA_80X = ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]; 

// CZ QS Logic
// CZ P-10 C / P-10 F CNC (quick ship) programs. Both models share the same
// two lists. Inforce WILD 1 came off quick ship - it stays in
// supported_lights, so it remains orderable as a custom build.
//   RH: Inforce APLc, Surefire X300 U-A/B, Streamlight TLR-1/HL, TLR-7/7A/7X
//   LH: Surefire X300 U-A/B, Streamlight TLR-7/7A/7X
// Both APLc ids are listed because the selectable one differs per model:
// the P-10 C carries the Glock/P-10C APLc, the P-10 F the Universal.
const LIGHTS_QS_CZ_P10_RH = ["inforce_aplc_uni", "inforce_aplc_glock", "x300u_a", "x300u_b", "tlr1", "tlr7"];
const LIGHTS_QS_CZ_P10_LH = ["x300u_a", "x300u_b", "tlr7"];
const LIGHTS_QS_CZ_SHADOW = ["tlr7", "x300u_a", "x300u_b"]; 

// FN QS Logic
const LIGHTS_QS_FN_509 = ["tlr1", "tlr7", "x300u_a", "x300u_b"]; 
const LIGHTS_QS_FN_EDGE = ["tlr1", "tlr7", "x300u_a", "x300u_b"]; 

// Glock QS Logic
const LIGHTS_QS_GLOCK_GTL = [
  "tlr1", "tlr2", "tlr7", "tlr7_hlx", 
  "x300u_a", "x300u_b", "x400", "xc2", "xvl2", "gtl_10"
];
const LIGHTS_QS_GLOCK_FULL = [
  "tlr1", "tlr2", "tlr7", "tlr7_hlx", 
  "x300u_a", "x300u_b", "xc2", "xvl2"
];

// Left-hand Glock quick ship. X400 Ultra and GTL 10 are not offered lefty, but
// stay in supported_lights so they remain orderable as a custom build. XC2,
// XVL2 and TLR-2/HL are no longer offered lefty at all (see the gates above),
// and Modlite PL350 is no longer offered on any model.
const LIGHTS_QS_GLOCK_LH = ["tlr1", "tlr7", "tlr7_hlx", "x300u_a", "x300u_b"];

const LIGHTS_QS_SHADOW_SYSTEMS = ["tlr1", "tlr7", "tlr7_hlx", "x300u_a", "x300u_b"]; 

const LIGHTS_QS_SIG_320_FULL = ["tlr1", "tlr7", "inforce_wild1", "inforce_wild2", "x300u_a", "x300u_b", "surefire_xc2"];
const LIGHTS_QS_SIG_LH_SAFE = ["tlr1", "tlr7", "x300u_a", "x300u_b"];
const LIGHTS_QS_SIG_MACRO = ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]; 

const LIGHTS_QS_COMMON = ["tlr1", "tlr7", "x300u_a", "x300u_b"]; 


// ==========================================
// 3. MAIN DATA EXPORT
// ==========================================
export const holsterData = {
  brands: [
    { id: "1911", name: "1911" },
    { id: "archon", name: "Archon Firearms" },
    { id: "arex", name: "AREX" },
    { id: "beretta", name: "Beretta" },
    { id: "browning", name: "Browning" },
    { id: "canik", name: "Canik" },
    { id: "cz", name: "CZ" },
    { id: "dw", name: "Dan Wesson" },
    { id: "fn", name: "FN" },
    { id: "glock", name: "Glock / Polymer80" },
    { id: "hk", name: "H&K (Heckler & Koch)" },
    { id: "iwi", name: "IWI" },
    { id: "kahr", name: "Kahr" },
    { id: "rost_martin", name: "Rost Martin" },
    { id: "ruger", name: "Ruger" },
    { id: "sccy", name: "SCCY" },
    { id: "shadow", name: "Shadow Systems" },
    { id: "sig", name: "Sig Sauer" },
    { id: "staccato", name: "Staccato / STI" },
    { id: "sw", name: "Smith & Wesson" },
    { id: "sphinx", name: "SPHINX" },
    { id: "springfield", name: "Springfield Armory" },
    { id: "steyr", name: "Steyr" },
    { id: "taurus", name: "Taurus" },
    { id: "walther", name: "Walther" },
    { id: "zermatt", name: "Zermatt Arms" },
  ],

  guns: [
    // --- 1911 ---
    { id: "1911_govt_nr", brand_id: "1911", name: "1911 Govt 5\" Non-Rail (NO SIG)", supported_lights: [] },
    { id: "1911_govt_rail", brand_id: "1911", name: "1911 Govt 5\" w/ Rail (NO SIG/FULL RAIL)", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" }, 
    { id: "1911_cmdr_nr", brand_id: "1911", name: "1911 4.25\" Commander Non-Rail (NO SIG)", supported_lights: [] }, 
    { id: "1911_cmdr_rail", brand_id: "1911", name: "1911 4.25\" Commander W/ Rail (NO SIG)", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" }, 
    { id: "1911_ultra", brand_id: "1911", name: "1911 3\" Ultra Carry (NO SIG)", supported_lights: [] },

    // --- ARCHON ---
    { id: "archon_type_b", brand_id: "archon", name: "ARCHON Type B", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_QS_ARCHON, lead_time: "5-7 Days" },
    { id: "archon_type_b_comp", brand_id: "archon", name: "ARCHON Type B W/VP Armory Comp", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_QS_ARCHON, lead_time: "5-7 Days" },

    // --- AREX ---
    { id: "arex_alpha", brand_id: "arex", name: "AREX Alpha", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL },
    { id: "arex_delta", brand_id: "arex", name: "AREX Delta (1.0 / 2.0 M & X)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_AREX_DELTA, qs_lb_lh: LIGHTS_QS_AREX_DELTA, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "arex_delta_l", brand_id: "arex", name: "AREX Delta L", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7"], qs_lb_lh: ["tlr7"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "arex_zero1_cp", brand_id: "arex", name: "AREX Zero 1 CP/TC", supported_lights: LIGHTS_UNIVERSAL },
    { id: "arex_zero1", brand_id: "arex", name: "AREX Zero 1", supported_lights: LIGHTS_UNIVERSAL },
    { id: "arex_zero1_tac", brand_id: "arex", name: "AREX Zero 1 Tactical", supported_lights: LIGHTS_UNIVERSAL },
    { id: "arex_zero2", brand_id: "arex", name: "AREX Zero 2", supported_lights: LIGHTS_UNIVERSAL, right_hand_only: true },

    // --- BERETTA ---
    { id: "beretta_apx_a1_fs", brand_id: "beretta", name: "Beretta APX-A1 Full Size", supported_lights: ["tlr7", "tlr7_sub_1913"], right_hand_only: true /* custom lead time only - no quick ship */ },
    { id: "beretta_apx_a1_c", brand_id: "beretta", name: "Beretta APX-A1 Compact", supported_lights: ["tlr7", "tlr7_sub_1913"], right_hand_only: true /* custom lead time only - no quick ship */ },
    { id: "beretta_92_m9", brand_id: "beretta", name: "Beretta M9A1/M9A3/M9A4/92G/92X (Not Performance)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "beretta_px4", brand_id: "beretta", name: "Beretta PX4 Storm", supported_lights: ["tlr7"] },
    { id: "beretta_px4_c", brand_id: "beretta", name: "Beretta PX4 Storm Compact", supported_lights: [] },

    // --- BROWNING ---
    { id: "browning_hp", brand_id: "browning", name: "Browning Hi-Power 9mm", supported_lights: [] },

    // --- CANIK ---
    { id: "canik_tp9sa", brand_id: "canik", name: "Canik TP9SA", supported_lights: LIGHTS_UNIVERSAL },
    { id: "canik_tp9sf", brand_id: "canik", name: "Canik TP9SF", supported_lights: LIGHTS_UNIVERSAL },
    { id: "canik_elite", brand_id: "canik", name: "Canik TP9SF ELITE", supported_lights: LIGHTS_UNIVERSAL },
    { id: "canik_sfx", brand_id: "canik", name: "Canik TP9SFX", supported_lights: LIGHTS_UNIVERSAL },
    { id: "canik_tti", brand_id: "canik", name: "Canik TTI Combat", supported_lights: LIGHTS_UNIVERSAL },

    // --- CZ ---
    { id: "cz_p01", brand_id: "cz", name: "CZ P01", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7"], qs_lb_lh: ["tlr7"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "cz_p07", brand_id: "cz", name: "CZ P-07", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7"], qs_lb_lh: ["tlr7"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "cz_p09", brand_id: "cz", name: "CZ P-09", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7"], qs_lb_lh: ["tlr7"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "cz_p10c", brand_id: "cz", name: "CZ P-10 C", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_CZ_P10_RH, qs_lb_lh: LIGHTS_QS_CZ_P10_LH, supported_lights: [...LIGHTS_UNIVERSAL.filter(id => id !== "inforce_aplc_uni"), "inforce_aplc_glock"], lead_time: "5-7 Days" },
    { id: "cz_p10f", brand_id: "cz", name: "CZ P-10 F", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_CZ_P10_RH, qs_lb_lh: LIGHTS_QS_CZ_P10_LH, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "cz_p10m", brand_id: "cz", name: "CZ P-10 M", qs_nlb_rh: true, supported_lights: [], right_hand_only: true, lead_time: "5-7 Days" },
    { id: "cz_p10s", brand_id: "cz", name: "CZ P-10 S", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7"], qs_lb_lh: ["tlr7"], supported_lights: ["tlr7", "tlr7_hlx"], lead_time: "5-7 Days" },
    { id: "cz_rami", brand_id: "cz", name: "CZ 2075 Rami", supported_lights: [] },
    { id: "cz_75b", brand_id: "cz", name: "CZ 75 B (9MM ONLY)", supported_lights: [] },
    { id: "cz_75c", brand_id: "cz", name: "CZ 75 Compact", supported_lights: [] },
    { id: "cz_97b", brand_id: "cz", name: "CZ 97 B", supported_lights: [] },
    { id: "cz_shadow2", brand_id: "cz", name: "CZ Shadow 2", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_CZ_SHADOW, qs_lb_lh: LIGHTS_QS_CZ_SHADOW, supported_lights: [...LIGHTS_UNIVERSAL, "tlr7_sub_1913"], lead_time: "5-7 Days" },
    { id: "cz_shadow2_carry", brand_id: "cz", name: "CZ Shadow 2 Carry", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_CZ_SHADOW, qs_lb_lh: LIGHTS_QS_CZ_SHADOW, supported_lights: [...LIGHTS_UNIVERSAL, "tlr7_sub_1913"], lead_time: "5-7 Days" },
    { id: "cz_shadow2_compact", brand_id: "cz", name: "CZ Shadow 2 Compact", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_CZ_SHADOW, qs_lb_lh: LIGHTS_QS_CZ_SHADOW, supported_lights: [...LIGHTS_UNIVERSAL, "tlr7_sub_1913"], lead_time: "5-7 Days" },
    { id: "cz_sp01_tac", brand_id: "cz", name: "CZ SP-01 Tactical", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "cz_sp01_phan", brand_id: "cz", name: "CZ SP01 Phantom", supported_lights: LIGHTS_UNIVERSAL },

    // --- DANIEL DEFENSE ---
    // Daniel H9 removed: it was custom-lead-time only, and custom options are
    // no longer offered on this model. Brand "daniel" removed with it.

    // --- DAN WESSON ---
    { id: "dw_dwx_full", brand_id: "dw", name: "DW DWX Full Size", qs_nlb_rh: true, right_hand_only: true, supported_lights: [], lead_time: "5-7 Days" },
    { id: "dw_dwx_compact", brand_id: "dw", name: "DW DWX Compact (NON-RAILED ONLY)", qs_nlb_rh: true, right_hand_only: true, supported_lights: [], lead_time: "5-7 Days" },

    // --- FN ---
    { id: "fn_309", brand_id: "fn", name: "FN 309", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },
    { id: "fn_57", brand_id: "fn", name: "FN 5.7", supported_lights: LIGHTS_UNIVERSAL },
    { id: "fn_57_mk3", brand_id: "fn", name: "FN 5.7 Mk3", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "fn_503", brand_id: "fn", name: "FN 503", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },
    { id: "fn_509_cc_edge", brand_id: "fn", name: "FN 509 CC EDGE", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "fn_509_ls_edge", brand_id: "fn", name: "FN 509 LS EDGE", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] /* no custom options - quick ship lights only */, lead_time: "5-7 Days" },
    { id: "fn_509", brand_id: "fn", name: "FN 509 / 509M / TAC", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_FN_509, qs_lb_lh: LIGHTS_QS_FN_509, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "fn_509c", brand_id: "fn", name: "FN 509C / 509C Tactical", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "fn_510", brand_id: "fn", name: "FN 510 / 545 Tactical", supported_lights: LIGHTS_UNIVERSAL },
    { id: "fn_hi_power_2022", brand_id: "fn", name: "FN High Power (2022)", supported_lights: [] },
    { id: "fn_reflex", brand_id: "fn", name: "FN REFLEX / XL MRD", supported_lights: LIGHTS_SUB_1913 /* custom lead time only - no quick ship */ },
    { id: "fn_fns9", brand_id: "fn", name: "FN FNS 9", supported_lights: LIGHTS_UNIVERSAL },
    { id: "fn_fns9c", brand_id: "fn", name: "FN FNS 9 Compact", supported_lights: LIGHTS_UNIVERSAL },
    { id: "fn_fnx45_tac", brand_id: "fn", name: "FN FNX 45 Tactical", supported_lights: LIGHTS_UNIVERSAL },
    { id: "fn_fnx9", brand_id: "fn", name: "FN FNX 9", supported_lights: LIGHTS_UNIVERSAL },

    // --- GLOCK & P80 ---
    { id: "glock_19_gen34", brand_id: "glock", name: "Glock 19/23/32 (FITS: GEN 3-6, 19M, 19X, G45, 19 MOS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_GLOCK_GTL, qs_lb_lh: LIGHTS_QS_GLOCK_LH, supported_lights: LIGHTS_GLOCK_GTL_RH, supported_lights_lh: LIGHTS_GLOCK_GTL, lead_time: "5-7 Days" },
    { id: "glock_17_31", brand_id: "glock", name: "GLOCK 17/31 (FITS: GEN 2-6, 17M, 17 MOS, G47)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_GLOCK_GTL, qs_lb_lh: LIGHTS_QS_GLOCK_LH, supported_lights: LIGHTS_GLOCK_GTL_RH, supported_lights_lh: LIGHTS_GLOCK_GTL, lead_time: "5-7 Days" },
    { id: "glock_20_21_gen24", brand_id: "glock", name: "Glock 20/21/21SF (Gen 2-4 ONLY)", supported_lights: LIGHTS_GLOCK },
    { id: "glock_20_21_gen5", brand_id: "glock", name: "Glock 20/21 (Gen 5 ONLY)", supported_lights: LIGHTS_GLOCK },
    { id: "glock_22_gen24", brand_id: "glock", name: "GLOCK 22 (Gen 2-4 ONLY)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_GLOCK_FULL, qs_lb_lh: LIGHTS_QS_GLOCK_LH, supported_lights: LIGHTS_GLOCK_RH, supported_lights_lh: LIGHTS_GLOCK, lead_time: "5-7 Days" },
    { id: "glock_22_gen5", brand_id: "glock", name: "Glock 22 (Gen 5)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_GLOCK_FULL, qs_lb_lh: LIGHTS_QS_GLOCK_LH, supported_lights: LIGHTS_GLOCK_RH, supported_lights_lh: LIGHTS_GLOCK, lead_time: "5-7 Days" },
    { id: "glock_23_gen5", brand_id: "glock", name: "Glock 23 (Gen 5)", supported_lights: LIGHTS_GLOCK },
    { id: "glock_26", brand_id: "glock", name: "GLOCK 26/27/33", qs_nlb_rh: true, supported_lights: [] },
    { id: "glock_30", brand_id: "glock", name: "Glock 30/29/29s", supported_lights: LIGHTS_GLOCK },
    { id: "glock_30s", brand_id: "glock", name: "Glock 30S", supported_lights: LIGHTS_GLOCK },
    { id: "glock_34", brand_id: "glock", name: "GLOCK 34/35 (FITS GEN 2-6, MOS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_GLOCK_GTL, qs_lb_lh: LIGHTS_QS_GLOCK_LH, supported_lights: LIGHTS_GLOCK_GTL_RH, supported_lights_lh: LIGHTS_GLOCK_GTL, lead_time: "5-7 Days" },
    { id: "glock_36", brand_id: "glock", name: "Glock 36", supported_lights: [] /* custom lead time only - no quick ship */ },
    { id: "glock_40", brand_id: "glock", name: "Glock 40", supported_lights: LIGHTS_GLOCK },
    { id: "glock_42", brand_id: "glock", name: "Glock 42", supported_lights: LIGHTS_TLR6_ONLY },
    { id: "glock_43", brand_id: "glock", name: "GLOCK 43 (Non-Railed)", supported_lights: LIGHTS_TLR6_ONLY /* custom lead time only - no quick ship */ },
    { id: "glock_43x", brand_id: "glock", name: "GLOCK 43X (Includes MOS Models)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_glock"], qs_lb_lh: ["tlr7_sub_glock"], supported_lights: ["tlr7_sub_glock"], lead_time: "5-7 Days" },
    { id: "glock_43_15rd", brand_id: "glock", name: "GLOCK 43/43X (Includes MOS) w/ 15 Rnd Factory Mag", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_glock"], qs_lb_lh: ["tlr7_sub_glock"], supported_lights: ["tlr7_sub_glock"], lead_time: "5-7 Days" },
    { id: "glock_48", brand_id: "glock", name: "GLOCK 48 (Includes MOS Models)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_glock"], qs_lb_lh: ["tlr7_sub_glock"], supported_lights: ["tlr7_sub_glock"], lead_time: "5-7 Days" },
    { id: "glock_48_15rd", brand_id: "glock", name: "GLOCK 48 (Includes MOS) w/ 15 Rnd Factory Mag", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_glock"], qs_lb_lh: ["tlr7_sub_glock"], supported_lights: ["tlr7_sub_glock"], lead_time: "5-7 Days" },
    { id: "p80_c", brand_id: "glock", name: "P80 PF940C (No Brownells Slides)", supported_lights: LIGHTS_UNIVERSAL },
    { id: "p80_v2", brand_id: "glock", name: "P80 PF940v2 (No Brownells Slides)", supported_lights: LIGHTS_UNIVERSAL },
    { id: "p80_sc", brand_id: "glock", name: "P80 PF940SC", supported_lights: [] },
    { id: "p80_cl", brand_id: "glock", name: "P80 PF940CL", supported_lights: LIGHTS_UNIVERSAL },

    // --- HK ---
    { id: "hk_p2000", brand_id: "hk", name: "H&K P2000", supported_lights: LIGHTS_UNIVERSAL.filter(id => !["x300u_a", "x300u_b", "tlr1", "tlr1_hlx", "x400"].includes(id)) },
    { id: "hk_p2000sk", brand_id: "hk", name: "H&K P2000SK", supported_lights: [] },
    { id: "hk_p30", brand_id: "hk", name: "H&K P30", supported_lights: LIGHTS_UNIVERSAL },
    { id: "hk_p30l", brand_id: "hk", name: "H&K P30L", supported_lights: LIGHTS_UNIVERSAL },
    { id: "hk_p30sk", brand_id: "hk", name: "H&K P30SK", supported_lights: [] },
    { id: "hk_45", brand_id: "hk", name: "H&K 45", supported_lights: LIGHTS_UNIVERSAL },
    { id: "hk_usp45_c", brand_id: "hk", name: "H&K USP 45 Compact", supported_lights: [] },
    { id: "hk_usp45_f", brand_id: "hk", name: "H&K USP 45 Full-Size", supported_lights: [] },
    { id: "hk_usp940_c", brand_id: "hk", name: "H&K USP 9/40 Compact", supported_lights: [] },
    { id: "hk_usp940_f", brand_id: "hk", name: "H&K USP 9/40 Full-Size", supported_lights: [] },
    { id: "hk_vp9", brand_id: "hk", name: "H&K VP9/A1-K (4.09\")", supported_lights: LIGHTS_UNIVERSAL },
    { id: "hk_vp9_l", brand_id: "hk", name: "H&K VP9 A1-F (4.53\")", supported_lights: LIGHTS_UNIVERSAL },
    { id: "hk_vp9sk", brand_id: "hk", name: "H&K VP9SK", supported_lights: [] },
    { id: "hk_vp40", brand_id: "hk", name: "H&K VP40", supported_lights: LIGHTS_UNIVERSAL },

    // --- IWI ---
    { id: "iwi_masada", brand_id: "iwi", name: "IWI Masada", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "iwi_masada_slim", brand_id: "iwi", name: "IWI Masada Slim", supported_lights: [] /* custom lead time only - no quick ship */ },
    { id: "iwi_masada_slim_elite", brand_id: "iwi", name: "IWI Masada Slim Elite", supported_lights: ["tlr7_sub_1913"] /* custom lead time only - no quick ship */ },

    // --- KAHR ---
    { id: "kahr_cm9", brand_id: "kahr", name: "Kahr CM9", qs_nlb_rh: true, supported_lights: [] },

    // --- ROST MARTIN ---
    { id: "rm1c", brand_id: "rost_martin", name: "Rost Martin RM1C", supported_lights: LIGHTS_UNIVERSAL },

    // --- RUGER ---
    { id: "ruger_sr22", brand_id: "ruger", name: "Ruger SR22 (Std Length)", supported_lights: LIGHTS_UNIVERSAL },
    { id: "ruger_sr9c", brand_id: "ruger", name: "Ruger SR9/40 Compact", supported_lights: LIGHTS_UNIVERSAL },

    // --- SCCY ---
    { id: "sccy_cpx1", brand_id: "sccy", name: "SCCY CPX-1", qs_nlb_rh: true, supported_lights: [] },
    { id: "sccy_cpx2", brand_id: "sccy", name: "SCCY CPX-2", qs_nlb_rh: true, supported_lights: [] },
    { id: "sccy_cpx3", brand_id: "sccy", name: "SCCY CPX-3", qs_nlb_rh: true, supported_lights: [] },
    { id: "sccy_dvg", brand_id: "sccy", name: "SCCY DVG-1RD", qs_nlb_rh: true, supported_lights: [] },

    // --- SHADOW SYSTEMS ---
    { id: "ss_cr920", brand_id: "shadow", name: "Shadow Systems CR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_glock"], qs_lb_lh: ["tlr7_sub_glock"], supported_lights: ["tlr7_sub_glock"], lead_time: "5-7 Days" },
    { id: "ss_mr920", brand_id: "shadow", name: "Shadow Systems MR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "ss_mr920l", brand_id: "shadow", name: "Shadow Systems MR920L", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "ss_xr920", brand_id: "shadow", name: "Shadow Systems XR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "ss_dr920", brand_id: "shadow", name: "Shadow Systems DR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "ss_dr920p", brand_id: "shadow", name: "Shadow Systems DR920P", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "ss_dr920l", brand_id: "shadow", name: "Shadow Systems DR920L", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SHADOW_SYSTEMS, qs_lb_lh: LIGHTS_QS_SHADOW_SYSTEMS, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },

    // --- SIG SAUER ---
    { id: "sig_1911_xfull", brand_id: "sig", name: "SIG 1911 X-FULL 5\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sig_1911_xcarry", brand_id: "sig", name: "SIG 1911 X-CARRY 4.25\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sig_1911_tacops_nr", brand_id: "sig", name: "Sig 1911 5\" TACOPS/SCORPION (No Rail)", supported_lights: [] },
    { id: "sig_2022_gen1", brand_id: "sig", name: "Sig 2022 (3-slot rail, GEN1)", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL },
    { id: "sig_2022_gen2", brand_id: "sig", name: "Sig P2022 Gen2", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sig_p211_gto", brand_id: "sig", name: "SIG P211-GTO/GT5", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], lead_time: "5-7 Days" },
    { id: "sig_p211_gt4", brand_id: "sig", name: "Sig Sauer P211-GT4", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], lead_time: "5-7 Days" },
    { id: "sig_p220_rail", brand_id: "sig", name: "Sig P220 w/ Rail (NO COMBAT)", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sig_p225_a1", brand_id: "sig", name: "Sig P225 A1", supported_lights: [] },
    { id: "sig_p226_mk25", brand_id: "sig", name: "Sig P226 Mk25", supported_lights: LIGHTS_UNIVERSAL /* custom lead time only - no quick ship */ },
    { id: "sig_p226r", brand_id: "sig", name: "SIG P226 (SAO Legion, P226 SIG Rail, DOES NOT FIT XFIVE LEGION)", supported_lights: LIGHTS_UNIVERSAL /* custom lead time only - no quick ship */ },
    { id: "sig_p226_xcarry_legion", brand_id: "sig", name: "SIG P226-XCarry Legion (3.8\")", supported_lights: LIGHTS_UNIVERSAL.filter(id => id !== "surefire_xc3") /* custom lead time only - no quick ship */ },
    { id: "sig_p226_x_legion", brand_id: "sig", name: "SIG P226-X Legion (4.4\")", supported_lights: LIGHTS_UNIVERSAL.filter(id => id !== "surefire_xc3") /* custom lead time only - no quick ship */ },
    { id: "sig_p226_xfive_us", brand_id: "sig", name: "SIG P226-XFIVE/LEGION (2022 US VERSION)", supported_lights: LIGHTS_UNIVERSAL.filter(id => id !== "surefire_xc3") /* custom lead time only - no quick ship */ },
    { id: "sig_p229", brand_id: "sig", name: "SIG P229 (9mm Only)", supported_lights: LIGHTS_UNIVERSAL /* custom lead time only - no quick ship */ },
    { id: "sig_p238", brand_id: "sig", name: "Sig P238", supported_lights: [] },
    
    // Sig P320
    { id: "sig_p320_full", brand_id: "sig", name: "SIG P320FS (FITS: P320 FULL SIZE, M17, Xcarry Grip Modules)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "inforce_wild1", "inforce_wild2", "x300u_a", "x300u_b", "surefire_xc2"], qs_lb_lh: ["tlr1", "tlr7", "inforce_wild1", "inforce_wild2", "x300u_a", "x300u_b", "surefire_xc2"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sig_p320_compact", brand_id: "sig", name: "SIG P320C (FITS: XCARRY, XCOMPACT, M18, P320C TAC OPS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "inforce_wild1", "inforce_wild2", "x300u_a", "x300u_b", "surefire_xc2"], qs_lb_lh: ["tlr1", "tlr7", "inforce_wild1", "inforce_wild2", "x300u_a", "x300u_b", "surefire_xc2"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sig_p320_ptex_c", brand_id: "sig", name: "SIG 320C PF320PTEX™", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sig_p320_ptex_fs", brand_id: "sig", name: "SIG 320FS PF320PTEX™", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    
    { id: "sig_p320_xten", brand_id: "sig", name: "SIG P320-XTEN", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, right_hand_only: true, lead_time: "5-7 Days" },
    { id: "sig_p320_xten_comp", brand_id: "sig", name: "SIG P320-XTEN COMP", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sig_p320_x5_legion", brand_id: "sig", name: "SIG 320 X5/LEGION", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "inforce_wild1", "x300u_a", "x300u_b"], qs_lb_lh: ["tlr1", "tlr7", "inforce_wild1", "x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    
    // Sig P365 Family
    { id: "sig_p365", brand_id: "sig", name: "SIG 365 (365x)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_p365"], qs_lb_lh: ["tlr7_sub_p365"], supported_lights: LIGHTS_SIG_365_STD, lead_time: "5-7 Days" },
    { id: "sig_p365xl", brand_id: "sig", name: "SIG 365XL", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_sub_p365"], qs_lb_lh: ["tlr7_sub_p365"], supported_lights: LIGHTS_SIG_365_XL, lead_time: "5-7 Days" },
    
    { id: "sig_p365_axg_1", brand_id: "sig", name: "SIG P365-AXG Legion (GEN 1 ONLY)", supported_lights: LIGHTS_SUB_1913 /* custom lead time only - no quick ship */ },
    { id: "sig_p365_axg_2", brand_id: "sig", name: "SIG P365-AXG Black/Legion (GEN 2 ONLY)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_SIG_MACRO, qs_lb_lh: LIGHTS_QS_SIG_MACRO, supported_lights: LIGHTS_SIG_MACRO, lead_time: "5-7 Days" },
    { id: "sig_p365_fuse", brand_id: "sig", name: "SIG P365 FUSE", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"], qs_lb_lh: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"], supported_lights: LIGHTS_SIG_MACRO, lead_time: "5-7 Days" },
    { id: "sig_p365_macro", brand_id: "sig", name: "SIG P365 X-Macro (Fits Tacops Models)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"], qs_lb_lh: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"], supported_lights: LIGHTS_SIG_MACRO, lead_time: "5-7 Days" },

    // --- SIG P385 (new duty pistol) ---
    // Quick ship both hands, non-lightbearing and with the TLR-7 HL-X.
    // TLR-7/A/X ("tlr7") is NOT offered yet - planned for the following week.
    { id: "sig_p385_full", brand_id: "sig", name: "SIG P385-FULL", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_hlx"], qs_lb_lh: ["tlr7_hlx"], supported_lights: ["tlr7_hlx"] },
    { id: "sig_p385_carry", brand_id: "sig", name: "SIG P385-CARRY", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr7_hlx"], qs_lb_lh: ["tlr7_hlx"], supported_lights: ["tlr7_hlx"] },
    { id: "sig_p938", brand_id: "sig", name: "Sig P938", supported_lights: [] },

    // --- SMITH & WESSON ---
    { id: "sw_csx", brand_id: "sw", name: "S&W CSX", qs_nlb_rh: true, supported_lights: [], right_hand_only: true, lead_time: "5-7 Days" },
    { id: "sw_mp2_10_4", brand_id: "sw", name: "S&W M&P 2.0 10MM 4.0\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sw_mp2_10_46", brand_id: "sw", name: "S&W M&P 2.0 10MM 4.6\"", supported_lights: LIGHTS_UNIVERSAL },
    
    // M&P Quick Ship
    { id: "sw_mp1_36", brand_id: "sw", name: "S&W M&P 1.0 9/40 3.6\"", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp1_4", brand_id: "sw", name: "S&W M&P 1.0 9/40 4\"", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp1_425", brand_id: "sw", name: "S&W M&P 1.0 9/40 4.25\"", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp1_5", brand_id: "sw", name: "S&W M&P 1.0 9/40 5\"", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_36", brand_id: "sw", name: "S&W M&P 2.0 9/40 3.6\"", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_4", brand_id: "sw", name: "S&W M&P 2.0 9/40 4\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_425", brand_id: "sw", name: "S&W M&P 2.0 9/40 4.25\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_5", brand_id: "sw", name: "S&W M&P 2.0 9/40 5\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },

    // M&P 2.0 METAL / STEEL FRAME - flags mirror the polymer 2.0 entries above
    { id: "sw_mp2_metal_36", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 3.6\"", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_metal_4", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_metal_425", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.25\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp2_metal_5", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 5\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "sw_mp_45_c", brand_id: "sw", name: "S&W M&P Compact 45", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sw_mp_45_full", brand_id: "sw", name: "S&W M&P Full Size 45", supported_lights: LIGHTS_UNIVERSAL },
    

    // --- SPHINX ---
    { id: "sphinx_sdp", brand_id: "sphinx", name: "SPHINX SDP Compact", supported_lights: LIGHTS_UNIVERSAL },

    // --- SPRINGFIELD ---
    { id: "sp_xd_mod2", brand_id: "springfield", name: "Springfield XD MOD2 3.3\" 9/40", supported_lights: [] },
    { id: "sp_xd_sub", brand_id: "springfield", name: "Springfield XD 9/40 3\" Subcompact", supported_lights: [] },
    { id: "sp_xd_4", brand_id: "springfield", name: "Springfield XD 9/40 4\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sp_xd_5", brand_id: "springfield", name: "Springfield XD 9/40 Tactical 5\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sp_xd45_4", brand_id: "springfield", name: "Springfield XD 45 4\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sp_xd45_5", brand_id: "springfield", name: "Springfield XD 45 Tactical 5\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "sp_xds_33", brand_id: "springfield", name: "Springfield XDS 9/40/45 3.3\"", supported_lights: [] },
    { id: "sp_xds_4", brand_id: "springfield", name: "Springfield XDS 9/40/45 4\"", supported_lights: [] },
    { id: "sp_xdm_38", brand_id: "springfield", name: "Springfield XDM 3.8", supported_lights: LIGHTS_UNIVERSAL },

    // --- STACCATO ---
    // Staccato: quick ship only. supported_lights is cut to the CNC list so
    // no custom-lead-time configuration can be selected.
    { id: "staccato_c2", brand_id: "staccato", name: "Staccato C2", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_COMMON, qs_lb_lh: LIGHTS_QS_COMMON, supported_lights: LIGHTS_QS_COMMON, lead_time: "5-7 Days" },
    { id: "staccato_p", brand_id: "staccato", name: "Staccato P", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_COMMON, qs_lb_lh: LIGHTS_QS_COMMON, supported_lights: LIGHTS_QS_COMMON, lead_time: "5-7 Days" },
    { id: "staccato_xc", brand_id: "staccato", name: "Staccato XC", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_COMMON, qs_lb_lh: LIGHTS_QS_COMMON, supported_lights: LIGHTS_QS_COMMON, lead_time: "5-7 Days" },
    { id: "staccato_xl", brand_id: "staccato", name: "Staccato XL", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: LIGHTS_QS_COMMON, qs_lb_lh: LIGHTS_QS_COMMON, supported_lights: LIGHTS_QS_COMMON, lead_time: "5-7 Days" },
    { id: "staccato_cs", brand_id: "staccato", name: "Staccato CS (2023 and Prior Models ONLY)", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },

    // --- STEYR ---
    { id: "steyr_atc_5", brand_id: "steyr", name: "Steyr ATC 5\"", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },
    { id: "steyr_atd_4", brand_id: "steyr", name: "Steyr ATD 4\"", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },
    { id: "steyr_c9a2", brand_id: "steyr", name: "Steyr C9-A2", supported_lights: LIGHTS_UNIVERSAL, right_hand_only: true },
    { id: "steyr_m9a1", brand_id: "steyr", name: "Steyr M9-A1", supported_lights: LIGHTS_UNIVERSAL },
    { id: "steyr_m9a2", brand_id: "steyr", name: "Steyr M9-A2", supported_lights: LIGHTS_UNIVERSAL, right_hand_only: true },

    // --- TAURUS ---
    { id: "taurus_pt111", brand_id: "taurus", name: "Taurus PT111 G2", supported_lights: [] },

    // --- WALTHER ---
    { id: "walther_ccp", brand_id: "walther", name: "Walther CCP 9/40", supported_lights: [] }, 
    { id: "walther_pdp_4", brand_id: "walther", name: "Walther PDP Compact/ Full Size 4\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], qs_lb_lh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "walther_pdp_45", brand_id: "walther", name: "Walther PDP Full Size 4.5\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], qs_lb_lh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "walther_pdp_5", brand_id: "walther", name: "Walther PDP Full Size 5\"", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], qs_lb_lh: ["tlr1", "tlr7", "x300u_a", "x300u_b"], supported_lights: LIGHTS_UNIVERSAL, lead_time: "5-7 Days" },
    { id: "walther_q5", brand_id: "walther", name: "Walther Q5", qs_nlb_rh: true, supported_lights: LIGHTS_UNIVERSAL, right_hand_only: true, lead_time: "5-7 Days" },
    { id: "walther_ppq_4", brand_id: "walther", name: "Walther PPQ M2 4\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "walther_ppq_5", brand_id: "walther", name: "Walther PPQ M2 5\"", supported_lights: LIGHTS_UNIVERSAL },
    { id: "walther_pps_m1", brand_id: "walther", name: "Walther PPS M1", supported_lights: [] }, 
    { id: "walther_pps_m2", brand_id: "walther", name: "Walther PPS M2 9/40", supported_lights: [] }, 

    // --- ZERMATT ARMS ---
    { id: "zermatt_waltz9", brand_id: "zermatt", name: "Zermatt Arms Waltz 9", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [], lead_time: "5-7 Days" },

  ],

  // --- LIGHT OPTIONS ---
  lights: [
    { id: "inforce_apl", name: "Inforce APL" },
    { id: "inforce_aplc_glock", name: "Inforce APLc" },
    { id: "inforce_aplc_uni", name: "Inforce APLc (Universal)" },
    { id: "inforce_apl_3", name: "Inforce APL 3.0" },
    { id: "inforce_wild1", name: "Inforce WILD 1" },
    { id: "inforce_wild2", name: "Inforce WILD 2" },
    { id: "olight_pl_mini", name: "OLight PL-Mini" },
    { id: "olight_pl_mini2", name: "OLight PL-Mini 2" },
    { id: "olight_pl2", name: "OLight PL-2" },
    { id: "olight_pl_pro", name: "OLight PL-Pro" },
    { id: "sig_foxtrot1x", name: "Sig Foxtrot1X" },
    { id: "sig_foxtrot2r", name: "Sig Foxtrot2R" },
    { id: "tlr1", name: "Streamlight TLR-1 / HL" },
    { id: "tlr1_hlx", name: "Streamlight TLR-1 HL-X" },
    { id: "tlr2", name: "Streamlight TLR-2 / HL" },
    { id: "tlr7", name: "Streamlight TLR-7 / 7A / 7X" },
    { id: "tlr7_hlx", name: "Streamlight TLR-7 HL-X" },
    { id: "tlr7_sub_1913", name: "Streamlight TLR-7 SUB / HL-X SUB (1913)" },
    { id: "tlr7_sub_glock", name: "Streamlight TLR-7 SUB / HL-X SUB (G43X / 48)" },
    { id: "tlr7_sub_p365", name: "Streamlight TLR-7 SUB / HL-X SUB (P365)" },
    { id: "tlr6", name: "Streamlight TLR-6" },
    { id: "surefire_xc1b", name: "Surefire XC1-B" },
    { id: "surefire_xc1c", name: "Surefire XC1-C" },
    { id: "surefire_xc3", name: "Surefire XC3" },
    { id: "surefire_xsc", name: "Surefire XSC-365" },
    { id: "surefire_xsc_b", name: "Surefire XSC-B" },
    { id: "surefire_xsc_a", name: "Surefire XSC-A" },
    { id: "x300u_a", name: "Surefire X300 (U) A" },
    { id: "x300u_b", name: "Surefire X300 (U) B" },
    { id: "x400", name: "Surefire X400 Ultra" },
    { id: "xc2", name: "Surefire XC2" },
    { id: "xvl2", name: "Surefire XVL2" },
    { id: "modlite_pl350", name: "Modlite PL350" },
    { id: "gtl_10", name: "Glock GTL 10" }
  ],

  // --- OPTIONS ---
  hands: [ { id: "right", name: "Right Handed" }, { id: "left", name: "Left Handed" } ],
  
  lightbearing_options: [ 
      { id: "no", name: "Non-Lightbearing" }, 
      { id: "yes", name: "Lightbearing" } 
  ],

  cants: [
    { id: "no_cant", name: "No Cant (Standard)", price: 0 },
    { id: "10_degree", name: "10° Cant", price: 0 },
  ],

  // --- COLORS (MAPPED FOR $20 MARKUP) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 20),

  // --- MOUNTS ---
  mounts: [
    { 
      id: "rti", 
      name: "RTI Hanger", 
      price: 14.00, 
      img_layer_mount: "/images/mounts/rti_front.png", 
      img_layer_mount_back: "/images/mounts/rti_back.png",
      description: "G-Code RTI Hanger for QD mounting."
    },
    { 
      id: "qls_fork", 
      name: "SAFARILAND QLS Fork", 
      price: 17.99, 
      img_layer_mount: "/images/mounts/qls_front.png", 
      img_layer_mount_back: "/images/mounts/qls_back.png",
      description: "Quick Locking System fork only."
    },
    { 
      id: "qls_kit", 
      name: "SAFARILAND QLS/Q22 (Male & Female)", 
      price: 39.99, 
      img_layer_mount: "/images/mounts/qls_front.png", 
      img_layer_mount_back: "/images/mounts/qls_back.png",
      description: "Complete Quick Locking System kit (Fork & Receiver Plate)."
    },
    { 
      id: "tek_lok", 
      name: "Blade-Tech Tek-Lok Mount", 
      price: 12.50, 
      img_layer_mount: "/images/mounts/teklok_front.png", 
      img_layer_mount_back: "/images/mounts/teklok_back.png",
      description: "Secure, adjustable belt attachment system."
    },
    { 
      id: "tac_belt_standard", 
      name: "Tactical Belt Mount (Bolted Directly)", 
      price: 0, 
      description: "Bolted directly to the holster. Choose color and size below.",
      warning: "DESIGNED TO BE USED WITH OUR FULCRUM AND THIGHBAND OR EQUIVALENT THIGH BAND SYSTEM. If used as a standalone item, extreme outward torsion away from the body can result in cracks or breakages at the belt."
    },
    { 
      id: "dropleg_qls", 
      name: "Full Dropleg Setup with QLS", 
      price: 39.99, 
      description: "Complete setup including shroud, strap, and QLS system."
    },
    { 
      id: "dropleg_no_qls", 
      name: "Full Dropleg Setup (No QLS)", 
      price: 0, 
      description: "Complete setup bolted directly (No Quick Locking System)."
    },
    { 
      id: "no_mount", 
      name: "No Mount", 
      price: 0, 
      description: "Holster shell only, pre-drilled for standard mounting patterns."
    }
  ],

  // --- SUB-OPTIONS FOR TAC BELT ---
  tac_belt_colors: [
      { id: "black", name: "Black", price: 17.99 },
      { id: "coyote", name: "Coyote", price: 17.99 },
      { id: "od_green", name: "OD Green", price: 17.99 },
      { id: "light_grey", name: "Light Grey", price: 17.99 },
      { id: "foliage_green", name: "Foliage Green", price: 17.99 },
      { id: "multicam", name: "Multicam", price: 34.99 },
      { id: "multicam_black", name: "Multicam Black", price: 34.99 },
      { id: "multicam_tropic", name: "Multicam Tropic", price: 34.99 },
      { id: "multicam_arid", name: "Multicam Arid", price: 34.99 }
  ],

  tac_belt_sizes: [
      { id: "std_150", name: "Standard 1.50\"", price: 0 },
      { id: "std_175", name: "Standard 1.75\"", price: 0 },
      { id: "std_200", name: "Standard 2.0\"", price: 0 },
      { id: "short_150", name: "Short 1.50\"", price: 0 },
      { id: "short_175", name: "Short 1.75\"", price: 0 },
      { id: "short_200", name: "Short 2.0\"", price: 0 }
  ],

  // --- SUB-OPTIONS FOR DROPLEG ---
  fulcrum_colors: [
      { id: "black", name: "Black", price: 15.99 },
      { id: "carbon_fiber", name: "Carbon Fiber", price: 15.99 },
      { id: "coyote_carbon", name: "Coyote Tan Carbon Fiber", price: 15.99 }
  ],

  thigh_band_colors: [
      { id: "black", name: "Black", price: 16.99 },
      { id: "tan", name: "Tan", price: 16.99 }
  ],

  // --- MAG CARRIER ADDONS ---
  mag_carriers: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "yes_1", name: "Yes Add 1", price: 29.99 },
    { id: "yes_2", name: "Yes Add 2", price: 49.99 },
    { id: "mystery", name: "1 Mystery Limited Edition Kydex Pattern", price: 29.99 }
  ],

  // --- ADD-ON MAG MOUNTS (LOWER PRICING) ---
  mag_mounts: [
    { id: "clip_15", name: "1.5\" Injection Molded Clip", price: 0 },
    { id: "clip_175", name: "1.75\" Injection Molded Clip", price: 0 },
    { id: "dcc_ANRlogo", name: "1.5\" DCC Monoblock ANR Logo", price: 4.99 },
    { id: "dcc_nologo", name: "1.5\" DCC Monoblock No Logo", price: 4.49 },
    { id: "dcc_FDElogo", name: "1.5\" DCC Monoblock FDE w/ Logo", price: 4.99 },
    { id: "dcc_TOPOlogo", name: "1.5\" DCC Monoblock Topographical", price: 5.49 },
    { id: "neomag", name: "Neomag Alias TPost", price: 15.99 },
    { id: "neomag_receiver", name: "Neomag Alias TPost and Neomag Alias Belt Receiver", price: 49.99 }
  ],

  // --- EXTENDED THUMB SCREWS ---
  thumb_screws: [
    { id: "no", name: "No Thanks", price: 0 },
    { id: "yes", name: "Add Extended Thumb Screws", price: 8.50 },
  ],

  // --- EXTRAS ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};